/** Quyền hiển thị QR Device Management theo product app. */
export type AppProduct = 'lite' | 'mono' | 'pro' | string | null | undefined;

export function normalizeAppProduct(product: AppProduct): 'lite' | 'mono' | 'pro' | null {
  const p = String(product || '').trim().toLowerCase();
  if (p === 'lite' || p === 'mono' || p === 'pro') return p;
  return null;
}

/** Chỉ giữ máy đúng product (pro / lite / mono) — dùng cho dropdown lọc gallery. */
export function filterMachinesByAppProduct<T extends { appProduct?: AppProduct; machineCode: string }>(
  machines: T[],
  product: 'lite' | 'mono' | 'pro'
): T[] {
  return (machines || []).filter((m) => normalizeAppProduct(m.appProduct) === product);
}

export function getDeviceMgmtFeatures(
  product: AppProduct,
  opts?: { isStaffUser?: boolean }
): {
  showUpload: boolean;
  showControl: boolean;
  showEdit: boolean;
  showPhotos: boolean;
  showPhotobooth: boolean;
  showQrEdit: boolean;
  showColorApps: boolean;
} {
  const p = normalizeAppProduct(product);
  const staff = !!opts?.isStaffUser;
  /** Photobooth Simple chỉ máy Pro — lite / mono không có tab. */
  const showPhotobooth = p === 'pro';
  if (staff && (p === 'lite' || p === 'mono')) {
    return {
      showUpload: false,
      showControl: false,
      showEdit: false,
      showPhotos: true,
      showPhotobooth: false,
      showQrEdit: false,
      showColorApps: false,
    };
  }
  if (staff) {
    return {
      showUpload: true,
      showControl: false,
      showEdit: true,
      showPhotos: true,
      showPhotobooth,
      showQrEdit: true,
      showColorApps: true,
    };
  }
  if (p === 'mono') {
    return {
      showUpload: false,
      showControl: true,
      showEdit: false,
      showPhotos: true,
      showPhotobooth: false,
      showQrEdit: false,
      showColorApps: true,
    };
  }
  if (p === 'lite') {
    return {
      showUpload: true,
      showControl: true,
      showEdit: false,
      showPhotos: true,
      showPhotobooth: false,
      showQrEdit: true,
      showColorApps: true,
    };
  }
  return {
    showUpload: true,
    showControl: true,
    showEdit: true,
    showPhotos: true,
    showPhotobooth,
    showQrEdit: true,
    showColorApps: true,
  };
}

/** Màu chip Lite / Mono / Pro — khác nhau cho dễ nhận. */
export function getAppProductChipProps(product: AppProduct): {
  color: 'default' | 'info' | 'warning';
  sx?: Record<string, unknown>;
} {
  const p = String(product || '').trim().toLowerCase();
  if (p === 'lite') {
    return { color: 'info' }; // xanh dương
  }
  if (p === 'mono') {
    return {
      color: 'default',
      sx: { bgcolor: '#374151', color: '#fff' }, // xám đậm
    };
  }
  if (p === 'pro') {
    return { color: 'warning' }; // vàng/cam
  }
  return { color: 'default' };
}
